import { iconButtonClasses, lighten, styled } from '@mui/material';
import { SnackbarContent } from 'notistack';
import { Typography } from '@/core/ui';
export const SnackbarContentStyled = styled(SnackbarContent)(({ theme }) => [
    {
        borderRadius: '.625rem', // 10px is absent in the scale.
        width: '27rem', // 24rem was not enough for 'order import rule update failed' message.
        maxWidth: '27rem',
        minWidth: '27rem',
        overflow: 'hidden',
        backgroundColor: theme.palette.common.white,
        boxShadow: 
        // 'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px',
        'rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px',
        outlineColor: 'oklab(0% none none / .05)',
        outlineStyle: 'solid',
        outlineWidth: '1px',
    },
    theme.applyStyles('dark', {
        backgroundColor: theme.palette.zinc[700],
        boxShadow: theme.shadows[11],
    }),
]);
export const RootContainer = styled('div', {
    shouldForwardProp: (prop) => prop !== 'alignCenter' && prop !== 'variant',
})(({ theme, alignCenter, variant }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: alignCenter ? 'center' : 'flex-start',
    flex: 1,
    padding: '1rem',
    ...(variant === 'reconnect' && {
        backgroundColor: lighten(theme.palette.primary.backgroundLight, 0.75),
    }),
}));
export const IconContainer = styled('div')({
    display: 'flex',
    flexShrink: 0,
    marginRight: '0.75rem',
});
export const TextContentContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    // paddingTop: '.125rem',
    paddingBottom: '.125rem',
    flex: '1 1 0%',
    width: '0px',
});
export const CloseButtonContainer = styled('div')(({ theme }) => [
    {
        display: 'flex',
        flexShrink: 0,
        marginLeft: theme.spacing(4),
    },
    theme.applyStyles('dark', {
        [`.${iconButtonClasses.root}`]: {
            ':hover': {
                color: theme.palette.text.muted,
            },
        },
    }),
]);
export const SimpleSnackbarBodyTypography = styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.body1.fontSize,
    lineHeight: 1.4,
    color: theme.palette.text.muted,
    whiteSpace: 'pre-line',
    paddingTop: theme.spacing(1),
}));
